import { Phone, MapPin, ArrowRight, Mail } from "lucide-react";
import { BUSINESS } from "@/lib/config";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-zinc-950" data-testid="site-footer">
      {/* Final CTA strip */}
      <div className="border-t border-b border-zinc-800 bg-orange-600">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 py-12 sm:flex-row sm:items-center">
          <div>
            <p className="font-mono-spec text-orange-950">Still reading?</p>
            <h3 className="mt-1 font-display text-4xl text-white sm:text-5xl">
              Let&apos;s build your part.
            </h3>
          </div>
          <button
            onClick={() => scrollToId("book")}
            className="inline-flex h-16 items-center justify-center gap-3 border-2 border-zinc-950 bg-zinc-950 px-8 font-display text-2xl uppercase tracking-wider text-white transition-colors duration-100 hover:bg-white hover:text-zinc-950"
            data-testid="footer-cta-btn"
          >
            Book a Call
            <ArrowRight className="h-6 w-6" />
          </button>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={BUSINESS.logoSrc}
              alt={`${BUSINESS.name} logo`}
              className="h-12 w-12 border border-zinc-800 bg-white object-contain p-0.5"
            />
            <span className="font-display text-2xl text-white">
              {BUSINESS.shortName}
            </span>
          </div>
          <p className="mt-4 max-w-md text-zinc-400">
            Precision laser cutting & engraving for makers, manufacturers, and
            commercial product teams. Based in {BUSINESS.location}.
          </p>
        </div>

        <div>
          <p className="font-mono-spec text-zinc-500">Contact</p>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                href={BUSINESS.phoneTel}
                className="flex items-center gap-2 text-white hover:text-orange-500"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4" />
                {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a
                href={BUSINESS.emailMailto}
                className="flex items-center gap-2 text-white hover:text-orange-500"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" />
                {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-center gap-2 text-zinc-400">
              <MapPin className="h-4 w-4" />
              {BUSINESS.location}
            </li>
          </ul>
        </div>

        <div>
          <p className="font-mono-spec text-zinc-500">Sections</p>
          <ul className="mt-4 space-y-3">
            {[
              ["Services", "services"],
              ["Materials", "materials"],
              ["Process", "process"],
              ["Book a Call", "book"],
              ["FAQ", "faq"],
            ].map(([label, id]) => (
              <li key={id}>
                <button
                  onClick={() => scrollToId(id)}
                  className="text-white hover:text-orange-500"
                  data-testid={`footer-link-${id}`}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-800">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 sm:flex-row sm:items-center">
          <p className="font-mono-spec text-zinc-600">
            © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </p>
          <p className="font-mono-spec text-zinc-600">
            Designed for makers. Built for speed.
          </p>
        </div>
      </div>
    </footer>
  );
}
